import {
  TDiscountTableDataCalculation,
  TServicesTableDataCalculation,
} from 'modules/accommodations/features/reservations/models';

export const constructPayloadForAPI = (
  unitId: string,
  servicesData: TServicesTableDataCalculation[],
  discountsData: TDiscountTableDataCalculation[],
) => {
  return {
    unitId: unitId.toString(),
    calculationServices: servicesData,
    calculationDiscountServices: discountsData,
  };
};
